"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'directRefund',
  props: {
    dialogVisibleDirectRefund: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    orderNo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pram: {
        returnType: 1,
        orderNo: '',
        detailList: []
      },
      dialogVisible: this.dialogVisibleDirectRefund,
      productList: [],
      multipleSelection: [],
      refundPrice: 0,
      //预计退款金额
      loading: false
    };
  },
  watch: {
    dialogVisibleDirectRefund: {
      handler: function handler(val) {
        this.dialogVisible = val;
      },
      deep: true
    },
    'pram.returnType': {
      handler: function handler(val) {
        if (this.multipleSelection.length === 0 && val === 2) {
          this.refundPrice = 0;
        } else {
          this.multipleSelection = [];
          this.getRefundPrice(this.productList);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.orderProDetail();
  },
  methods: {
    //决定这一行的 CheckBox 是否可以勾选
    selectable: function selectable(row, index) {
      if (row.deliveryNum === row.payNum) {
        return false;
      } else {
        return true;
      }
    },
    limitCount: function limitCount(row, i) {
      if (row.num > row.payNum) row.num = row.payNum;
      this.getRefundPrice(this.multipleSelection);
    },
    // 商品信息
    orderProDetail: function orderProDetail() {
      var _this = this;
      this.loading = true;
      (0, _order.orderProDetailApi)(this.orderNo).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this.productList = res;
                _this.productList.map(function (item) {
                  return _this.$set(item, 'num', 1);
                });
                _this.getRefundPrice(_this.productList);
                _this.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this.loading = false;
      });
    },
    //预计退款金额
    getRefundPrice: function getRefundPrice(multipleSelection) {
      var _this2 = this;
      // 预计退款金额 = （可退总额/可退数量 * 退款数量）表格选中之和
      // 可退总额 = 购买金额-已退款金额，payPrice - refundPrice
      // 可退数量 = 购买数量-已退款数量-申请退款数量，payNum-refundNum-applyRefundNum
      // 可退总额/可退数量 onePrice = this.$selfUtil.Division(payPrice , refundPrice); //除法
      this.refundPrice = multipleSelection.reduce(function (accumulator, currentValue) {
        var onePrice = _this2.$selfUtil.Division(currentValue.payPrice - currentValue.refundPrice, currentValue.payNum - currentValue.refundNum - currentValue.applyRefundNum);
        //可退数量
        var refundNum = _this2.pram.returnType === 1 ? currentValue.payNum - currentValue.refundNum - currentValue.applyRefundNum : currentValue.num;
        return accumulator + onePrice * refundNum;
      }, 0);
    },
    // 选择商品
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = [];
      this.multipleSelection.map(function (item) {
        data.push({
          id: item.id,
          num: item.num
        });
      });
      this.getRefundPrice(this.multipleSelection);
    },
    //提交
    handlerSubmit: function handlerSubmit() {
      var _this3 = this;
      if (this.pram.returnType === 2 && this.multipleSelection.length === 0) return this.$message.warning('分单退款请选择商品！');
      this.pram.orderNo = this.orderNo;
      this.multipleSelection.map(function (item) {
        _this3.pram.detailList.push({
          num: item.num,
          orderDetailId: item.id
        });
      });
      (0, _order.orderDirectRefundApi)(this.pram).then(function () {
        _this3.$message.success('操作成功');
        _this3.$emit('handlerSuccessSubmit');
      });
    },
    //取消
    handlerClose: function handlerClose() {
      this.$emit('handlerSuccessClose');
    }
  }
};